const PRODUCT_HOSTS = new Set([
	"app.one.dreambroker.com",
	"auth.one.dreambroker.com",
	"store.dreambroker.com",
])

const isProductLink = (url: URL): boolean => {
	const hostname = url.hostname.replace(/^www\./, "")

	if (PRODUCT_HOSTS.has(hostname)) return true

	return (
		(hostname === "dreambroker.com" ||
			hostname.endsWith(".dreambroker.com")) &&
		url.pathname.startsWith("/studio")
	)
}

const stripProductLinkTracking = (event: MouseEvent): void => {
	const target = event.target
	if (!(target instanceof Element)) return

	const link = target.closest("a")
	if (!link) return

	let url: URL
	try {
		url = new URL(link.href)
	} catch {
		return
	}

	if (!isProductLink(url) || !url.searchParams.has("_gl")) return

	url.searchParams.delete("_gl")
	link.href = url.toString()
}

export default stripProductLinkTracking
